// extracted by mini-css-extract-plugin
module.exports = {"DocsPage":"DocsPage_DocsPage__2UCIh","Download":"DocsPage_Download__ufbQF"};